import '../styles/pages/_community-crop.scss';
import { DOMUtils } from '../utils/dom-utils.js';

const { getElementById, querySelector, querySelectorAll, createElement, hasClass, ready } =
  DOMUtils;

/**
 * Community Crop module for handling menu interactions and FAQ toggles
 */
class CommunityCropManager {
  constructor() {
    this.elements = {};
  }

  init() {
    this.cacheElements();
    this.bindEvents();
    this.initializeMenus();
    this.initializeFAQ();
  }

  cacheElements() {
    this.elements = {
      content: getElementById('content'),
      ourGardensMenu: querySelector('#our-gardens-menu'),
      preparationMenu: querySelector('#preparation-menu'),
      ourGardens: getElementById('our-gardens'),
      preparation: getElementById('preparation'),
      ourGardensCaret: querySelector('#our-gardens + .caret'),
      preparationCaret: querySelector('#preparation + .caret'),
    };
  }

  bindEvents() {
    const { ourGardens, preparation, ourGardensCaret, preparationCaret } = this.elements;

    if (ourGardens) {
      ourGardens.addEventListener('click', this.toggleGardenMenu.bind(this));
    }
    if (ourGardensCaret) {
      ourGardensCaret.addEventListener('click', this.toggleGardenMenu.bind(this));
    }

    if (preparation) {
      preparation.addEventListener('click', this.togglePreparationMenu.bind(this));
    }
    if (preparationCaret) {
      preparationCaret.addEventListener('click', this.togglePreparationMenu.bind(this));
    }
  }

  toggleElement(selector) {
    const element = querySelector(selector);
    if (element) {
      element.style.display = element.style.display === 'none' ? '' : 'none';
    }
    return true;
  }

  toggleGardenMenu() {
    return this.toggleElement('#our-gardens-menu');
  }

  togglePreparationMenu() {
    return this.toggleElement('#preparation-menu');
  }

  initializeMenus() {
    const { content } = this.elements;

    this.toggleGardenMenu();
    if (content && hasClass(content, 'garden')) {
      this.toggleGardenMenu();
    }

    this.togglePreparationMenu();
    if (content && hasClass(content, 'preparation')) {
      this.togglePreparationMenu();
    }
  }

  initializeFAQ() {
    const { content } = this.elements;

    if (!content || !hasClass(content, 'faq')) {
      return;
    }

    querySelectorAll('#content.faq dd').forEach((dd) => (dd.style.display = 'none'));

    querySelectorAll('#content.faq dt').forEach((dt) => {
      dt.addEventListener('click', this.handleFAQClick.bind(this));
    });

    this.createShowAllToggle();
  }

  handleFAQClick(e) {
    const next = e.target.nextElementSibling;
    if (next && next.tagName === 'DD') {
      next.style.display = next.style.display === 'none' ? '' : 'none';
    }
    return true;
  }

  createShowAllToggle() {
    const h1 = querySelector('#content.faq h1');
    if (!h1) {
      return;
    }

    const showAllLink = createElement(
      'a',
      {
        id: 'show-all',
        href: '#',
      },
      'show all'
    );

    h1.after(showAllLink);

    showAllLink.addEventListener('click', this.handleShowAllClick.bind(this));
  }

  handleShowAllClick(e) {
    e.preventDefault();

    const allDDs = querySelectorAll('#content.faq dd');
    const anyVisible = Array.from(allDDs).some((dd) => dd.style.display !== 'none');

    allDDs.forEach((dd) => (dd.style.display = anyVisible ? 'none' : ''));

    const showAllLink = e.target;
    showAllLink.textContent = anyVisible ? 'show all' : 'hide all';

    return true;
  }
}

// Export for testing
export { CommunityCropManager };

// Initialize when DOM is ready
ready(() => {
  const communityCropManager = new CommunityCropManager();
  communityCropManager.init();
});
